import { ReactNode } from "react";
import { createUseStyles } from "$utils/createUseStyles";
import clsx from "clsx";
import { theme } from "$utils/theme/bataillog";

import { publicIconPath } from "$utils/constants";

type Props = {
  children: ReactNode;
  containerClassName?: string;
  onReview?: () => void;
};
function ConnexionLayout({
  children,
  containerClassName = "",
  onReview,
}: Props) {
  const classes = useStyles();
  return (
    <div className={classes.connection}>
      <div className={classes.ImgContainer} />
      <div className={clsx(classes.ConnectContainer, containerClassName)}>
        {typeof onReview === "function" && (
          <div className={classes.reviewLinkContainer} onClick={onReview}>
            <div className={classes.linkReview}>
              <img alt="ico-batail" src={`${publicIconPath}/arrow-back.svg`} />
            </div>
            Retour
          </div>
        )}
        {children}
      </div>
    </div>
  );
}

const useStyles = createUseStyles(() => ({
  connection: {
    minHeight: "var(--fullVh)",
    flex: "1",
    display: "flex",
    background: theme.color.gray1,
  },
  ImgContainer: {
    background: 'transparent url("./images/image_plateforme.png") 50% 57%',
    backgroundSize: "cover",
    flex: 1,
  },
  ConnectContainer: {
    maxHeight: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flex: "1",
    position: "relative",
    background: `${theme.color.white}`,
  },
  linkReview: {
    height: 46,
    width: 46,
    cursor: "pointer",
    border: `1px solid ${theme.color.gray2}`,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 10,
  },
  ConnexionLayout: {
    position: "relative",
  },
  reviewLinkContainer: {
    position: "absolute",
    top: 30,
    left: 80,
    display: "flex",
    alignItems: "center",
    fontSize: 14,
  },
}));

export default ConnexionLayout;
